import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeGetGoodsCommerceFbkSkuCodeResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/goods-commerce-fbk';

/**
 * [상품관리][상품 등록] FBK 상품 상세 조회 API
 */
export const fetchGoodsCommerceFbkSkuCode = async (skuCode: string) => {
  const { data } = await axiosInstance.get<TypeGetGoodsCommerceFbkSkuCodeResponse>(`${ENDPOINT}/${skuCode}`);
  return data.data;
};

/**
 * [상품관리][상품 등록] FBK 상품 상세 조회 Query Hook
 */
export const useGetGoodsCommerceFbkSkuCodeQuery = ({
  skuCode,
  enabled = true,
}: {
  skuCode: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: productKeys.goodsCommerceFbkSkuCode(skuCode),
    queryFn: () => fetchGoodsCommerceFbkSkuCode(skuCode),
    enabled: enabled && !!skuCode,
    staleTime: 0,
    gcTime: 0,
  });
};
